 <ng-container *transloco="let t;">
      <form [formGroup]="formGroup">
        @for(field of group.fields; track field.field_name) {
          @if(field.type === 'default') {
            <div class="mb-1">
              <app-dynamic-field
                [field]="field"
                [formGroup]="formGroup"
                [documentData]="documentData"
                [tags]="tags"
                [sectionName]="sectionName"
                [hasFullAccess]="hasFullAccessToDocument"
                [canEdit]="canEdit"
                (fieldAction)="handleFieldAction($event)">
              </app-dynamic-field>
            </div>
          }
        }
      </form>
    </ng-container>